import { Box, Stack, StackProps, Typography } from '@mui/material'
import { C1EmptyIndicator } from 'components/core/empty-indicator/C1EmptyIndicator'
import { C1Icon } from 'components/core/icons/C1Icon'
import { LucideIcon } from 'lucide-react'
import { FC } from 'react'

type TaskKeyValueMetadataRowProps = {
    label: React.ReactNode
    value: React.ReactNode
    Icon?: LucideIcon
    color?: string
    variant?: 'aligned' | 'ragged'
    align?: 'top' | 'center'
}

export const TaskKeyValueMetadataRow: FC<TaskKeyValueMetadataRowProps & StackProps> = ({ label, value, Icon, color, variant = 'aligned', align = 'center', ...rest }) => (
    <Stack direction="row" alignItems={align === 'top' ? 'flex-start' : 'center'} spacing={variant === 'aligned' ? 3 : 2} {...rest}>
        <Stack direction="row" alignItems="center" spacing={1} sx={{ width: variant === 'aligned' ? '10rem' : 'auto' }}>
            {Icon && <C1Icon icon={Icon} sx={{ color: color || 'text.secondary' }} />}
            <Typography sx={{ color: color || 'text.secondary' }}>{label}</Typography>
        </Stack>
        {value ? <Box sx={{ color: color || 'text.primary' }}>
            {value}
        </Box> : <C1EmptyIndicator />}
    </Stack>
)
